<template>
  <div>
    <b-card class="standardpage border-none">
      <b-card-header>
        <b-row>
          <b-col cols="12" sm="6" class="text-right text-sm-left pt-1">
            <i :class="clientaccounttypes.icon" class="mr-1"></i>
            <span>{{ clientaccounttypes.title }}</span>
          </b-col>
        </b-row>
      </b-card-header>

      <div v-if="!component" class="availtable datatable">
        <b-card class="w-100pct mb-2">
          <b-card-body class="py-0">

            <b-row v-if="!showfilter">
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Name" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="name" :debounce="clientaccounttypes.debounce"
                      placeholder="Description"></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!name" @click="name = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
        <div class="px-3">
          <d-table classdivtable="availtable datatable" refid="clientaccounttypes" :icon="clientaccounttypes.icon"
            :busy="clientaccounttypes.busy" :toolbarlibrary="clientaccounttypes.toolbarlibrary"
            :tools="clientaccounttypes.tools" :badges="clientaccounttypes.badges" :fields="clientaccounttypes.fields"
            :items="clientaccounttypes.items" :limit="clientaccounttypes.limit"
            :downloaded="clientaccounttypes.downloaded" :page="clientaccounttypes.page" @load="clientaccounttypes_load"
            @click="clientaccounttypes_click" @changed="clientaccounttypes_click('save', $event)"
            @select="clientaccounttypes_select">
          </d-table>
        </div>
      </div>

      <div v-if="component">
        <component :is="component" :selection="clientaccounttypes.selected" :config="cconfig"
          @discard="clientaccounttypes_click('discard')" @go="clientaccounttypes_click('go')"></component>
      </div>
      <b-card-footer class="mt-2 ml-1">
        <div class="text-center">
          <b-button squared size="sm" variant="outline-primary" @click="$emit('discard')">
            <i class="fa fa-bars mr-2"></i>All Codes
          </b-button>
        </div>
      </b-card-footer>

    </b-card>
  </div>
</template>


<script>
import gql from "graphql-tag";

import ClientAccountTypeEdit from "./Components/ClientAccountTypeEdit";

export default {
  name: "ClientAccountType",
  components: { ClientAccountTypeEdit },
  watch: {
    async name() {
      await this.clientaccounttypes_load(0);
    },
  },
  data() {
    return {
      name: null,

      clientaccounttypes: {
        title: "Client Account Types",
        icon: "fa fa-list",
        debounce: 500,
        busy: false,
        page: 1,
        offset: 0,
        limit: 15,
        tools: "go,filter,download,add,edit,deleteconfirm",
        toolbarlibrary: [],
        fields: [
          {
            key: "selected",
            label: "...",
            class: "text-center w-25px",
          },
          {
            key: "icon",
            label: "",
            class: "text-center w-35px",
          },
          {
            key: "id",
            label: "Code",
            sortable: true,
          },
          {
            key: "name",
            label: "Description",
            sortable: true,
          },
          {
            key: "updated_by",
            label: "Updated By",
            sortable: true,
            class: "text-center d-none d-sm-table-cell",
          },
          {
            key: "updated_at",
            label: "Updated At",
            sortable: true,
            class: "text-center d-none d-sm-table-cell",
          },
          {
            key: "actions",
            label: "Actions",
            class: "actions w-100px",
          },
        ],
        badges: [],
        items: [],
        selected: [],
        downloaded: [],
        denied: [],
      },
    };
  },
  async mounted() {
    await this.clientaccounttypes_load();
  },

  methods: {
    async clientaccounttypes_load(offset, limit, page) {
      let state = this.clientaccounttypes;

      if (offset || offset == 0) {
        state.offset = offset
      }
      if (limit || limit == 0) {
        state.limit = limit
      }
      if (page) {
        state.page = page
      }

      state.busy = true;

      let variables = {
        offset: state.offset,
        limit: state.limit,

        name: this.name,
        dateformat: "DD/MM/YYYY"
      };
      console.log("variables", variables);

      try {
        const response = await this.$apollo.query({
          query: gql`
              query clientaccounttypes(
                $limit: Int
                $offset: Int
                $name: String            
                $dateformat: String                
              ) {
                clientaccounttypes(
                  limit: $limit
                  offset: $offset
                  name: $name 
                  dateformat: $dateformat
              
                ) {
                id                                
                  name                             
                  rows
                  updated_at
                  updated_by
                }
              }
            `,
          variables,
        });

        // USE LOCAL VARIABLE

        state.downloaded = []
        if (limit == 0) {
          state.downloaded = response.data.clientaccounttypes
        } else {
          state.items = response.data.clientaccounttypes;
        }

      } catch (error) {
        console.log(error);
      }

      state.busy = false;
    },
    async clientaccounttypes_click(a, ss) {

      let state = this.clientaccounttypes;

      switch (a) {
        case "download_view":
          state.downloaded = []
          state.downloaded = state.items
          break;

        case "download_all":
          state.downloaded = []
          await this.clientaccounttypes_load(0, 0);
          break;
        case "filter":
          this.showfilter = !this.showfilter;
          break;
        case "discard":
          this.component = null;
          break;
        case "go":
          this.component = null;
          this.clientaccounttypes_load();
          break;
        case "add":
        case "edit":
          this.component = "ClientAccountTypeEdit";
          break;

        case "save":
          this.saveit(ss);
          break;

        case "delete":
          this.deleteit(ss);
          break;
      }
    },
    async clientaccounttypes_select(ss, tools) {

      let state = this.clientaccounttypes;

      state.selected = ss;
      let tool = null;

      if (tools) {
        let enabled = ["back", "save", "go", "filter", "add", "download"];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = false;
          }
        });
        // == 1
        enabled = ["edit"];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = ss.length == 1 ? false : true;
          }
        });
        // > 1
        enabled = ["deleteconfirm"];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = ss.length > 0 ? false : true;
          }
        });

        if (!state.denied) {
          state.denied = [];
        }
        state.denied.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.visible = false;
          }
        });
      }
    },

    async saveit(ss) {

      this.busy = true;

      let variables = { rows: this.cleanit(ss) };
      console.log("variables", variables);

      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
              mutation clientaccounttypes_save(
                $rows: [ClientAccountType_input]             
              ) {
                clientaccounttypes_save(rows: $rows) {
                    id                    
                    name
                    
                }
              }
            `,
          variables,
        });
        console.log(response);
        this.message = "<span class='text-primary'>Saved it.</span>";
      } catch (error) {
        this.message = "<span class='text-danger'>" + error.message + "</span>";
      }

      this.busy = false;
    },
    async deleteit(ss) {

      let rows = [];
      ss.forEach(function (v) {
        rows.push({ id: v.id });
      });

      let variables = {
        rows,
      };

      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
              mutation clientaccounttypes_delete(
                $rows: [ClientAccountType_input]
              ) {
                clientaccounttypes_delete(rows: $rows) {
                  id
                }
              }
            `,
          variables,
        });
      } catch (error) {
        console.log(error);
      }

      await this.clientaccounttypes_load(0);
    },
  },
};
</script>

<style></style>